/**
 * Page /admin/equipe — Équipe interne (administrateurs).
 * Wrapper sur AdminUsers en mode "team".
 */
import AdminUsers from "@/pages/AdminUsers";

export default function AdminTeam() {
    return <AdminUsers mode="team" />;
}
